<template>
  <div class="page-editor">
    <CRow>
      <CCol col="12" xl="10">
        <CCard class="pr-0">
          <CCardBody>
            <a-card class="edit-card" style="margin:0;">
              <span slot="title">
                <h6 class="w-100 mb-0 text-muted">
                  <router-link to="/blocks">Bloky</router-link>
                </h6>
                <div class="orders-header-row">
                  <span>{{ id !== 'add' ? block.title || block.des : 'Nový blok' }}</span>
                </div>
              </span>
              <span slot="extra">
              </span>

              <!-- Mobile toolbar -->
              <div class="d-xl-none mobile-toolbar" style="padding: 8px 16px; justify-content: flex-end;">
                <a-button type="primary" size="small" @click="handleSubmit">Uložiť</a-button>
              </div>

              <a-tabs :animated="false" :default-active-key="0">
                <!-- Tab: Základné -->
                <a-tab-pane :key="0" tab="Základné">
                  <div class="pl-4 pr-4 pt-3">
                    <a-form-item label="Názov" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-input v-model="block.title" />
                    </a-form-item>
                    <a-form-item label="Popis" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-input v-model="block.des" />
                    </a-form-item>
                    <a-form-item label="URL prefix" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-input v-model="block.urlprefix" />
                    </a-form-item>
                  </div>
                </a-tab-pane>

                <!-- Tab: BetaEditor -->
                <a-tab-pane :key="1" tab="BetaEditor">
                  <betaeditor :id="id" :ct="block.showon" :vc="block.vocabulary" data="builder" :values="block.builder" :lang="fieldData.language" :key="refreshAll" :url="vars.site_url + '/' + fieldData.language + '/' + fieldData.url" @changed="(ee) => onChildChangeBuilder(ee,'builder')"></betaeditor>
                </a-tab-pane>

                <!-- Tab: Priradenie -->
                <a-tab-pane :key="2" tab="Priradenie">
                  <div class="pl-4 pr-4 pt-3">
                    <a-form-item label="Typ obsahu" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-radio-group :options="contenttypes" v-model="block.showon" />
                    </a-form-item>
                    <a-form-item label="Taxonómia" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-radio-group :options="taxonomies" v-model="block.vocabulary" />
                    </a-form-item>
                  </div>
                </a-tab-pane>

                <!-- Tab: Zobrazenie -->
                <a-tab-pane :key="3" tab="Zobrazenie">
                  <div class="pl-4 pr-4 pt-3">
                    <a-form-item label="Zobraziť na stránkach" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-textarea v-model="block.pages" :rows="4" />
                      <div class="text-muted small">Tvar: node/xxx, jednotlivé stránky odenterovať</div>
                    </a-form-item>
                    <a-form-item label="Schovať na stránkach" :label-col="{span:4}" :wrapper-col="{span:20}">
                      <a-textarea v-model="block.notpages" :rows="4" />
                      <div class="text-muted small">Tvar: node/xxx, jednotlivé stránky odenterovať</div>
                    </a-form-item>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- Pravý panel -->
      <CCol col="12" xl="2" class="sidebar-actions-col">
        <CCard class="pl-0">
          <CCardBody>
            <div class="filter-panel">
              <div class="filter-head">
                <span class="filter-title">Nastavenia</span>
              </div>
              <div class="p-3">
                <div class="filter-group">
                  <label class="filter-label">Sekcia</label>
                  <a-select v-model="block.section" :options="sections" class="w-100" size="small" />
                </div>
                <div class="filter-group">
                  <label class="filter-label">Jazyk</label>
                  <a-select v-model="block.language" :options="languages" class="w-100" size="small" />
                </div>
                <router-link v-if="block.showon" :to="'/content/' + block.showon" class="mb-3 d-block">
                  <a-button block>Obsah typu: {{ contenttypeTitle }}</a-button>
                </router-link>
                <a-button type="primary" block @click="handleSubmit">Uložiť</a-button>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
    import {getURL} from "../api";
    import {authHeader} from "../_helpers";
    import {dataService} from "../_services";
    import Vue from "vue"
    import FormItem from 'ant-design-vue'
    import Image from "./content/Image";
    import {Cropper} from 'vue-advanced-cropper'
    import BetaEditor from "./content/BetaEditor";
    import ATextarea from "ant-design-vue/es/input/TextArea";

    Vue.use(FormItem);
    Vue.use(Cropper);

    export default {
        name: 'block',
        components: {ATextarea, "betaeditor": BetaEditor, 'image-upload': Image},
        props: ['id'],
        data() {
            return {
                url: getURL(),
                fieldData: {},
                block: {'language': '', 'title': '', 'description': '', 'nodeshow': '', 'builder': [], 'section': '0'},
                formData: null,
                refreshAll: 0,
                fileList: [],
                contenttypes: [],
                vars: [],
                languages: [],
                taxonomies: [],
                head: authHeader(),
                sections: [
                    {"value": '0', "label": 'Nepriradené (0)'},
                    {"value": '7', "label": 'Top stránky (7)'},
                    {"value": '1', "label": 'Hlavička stránky (1)'},
                    {"value": '2', "label": 'Bannerová časť stránky (2)'},
                    {"value": '3', "label": 'Hlavná sekcia (3)'},
                    {"value": '4', "label": 'Ľavá časť stránky (4)'},
                    {"value": '5', "label": 'Pravá časť stránky (5)'},
                    {"value": '6', "label": 'Päta stránky (6)'},
                    {"value": '8', "label": 'Vrch stránky, upozornenia (8)'},
                    {"value": '9', "label": 'Sidebar (9)'},
                ],
                colorsto: JSON.parse(localStorage.colors),
                ct: null,
                options: [],
                contenttype: { title: '', type: '' },
            }
        },
        computed: {
            contenttypeTitle() {
                if (!this.block.showon || !this.contenttypes.length) return this.block.showon;
                const found = this.contenttypes.find(c => c.value === this.block.showon);
                return found ? found.label : this.block.showon;
            }
        },
        methods: {
            onChildChangeBuilder(value, slug) {
                this.block.builder = JSON.stringify(value);
            },
            handleSubmit() {
                dataService.axiosPost(this.$options.name + "/" + this.id, this.block).then(results => {
                    if (results.data) {
                        this.$message.success('Obsah bol upravený');
                        if (isNaN(this.id)) {
                            this.$router.push('/block/' + results.data[0]);
                        }
                    } else {
                        this.$message.error('Pri ukladaní nastala chyba');
                    }
                });
            },
        },
        mounted() {
            if (this.id && this.id !== "add") {
                dataService.axiosFetch("block", this.id).then(results => {
                    this.block = results;
                    this.refreshAll = this.refreshAll + 1;
                });
            }
            dataService.axiosFetch("variable/site_url").then(results => {
                this.vars = results;
            });
            dataService.axiosFetch("contenttypes").then(results => {
                var roleops = [{"value": '', "label": 'Bez priradenia'}];
                results.forEach(obj => { roleops.push({"value": obj.slug, "label": obj.title}); });
                this.contenttypes = roleops;
            });
            dataService.axiosFetch('languages').then(results => {
                var roleops = [{"value": '', "label": 'Bez jazyka'}];
                results.forEach(obj => { roleops.push({"value": obj.short, "label": obj.title}); });
                this.languages = roleops;
            });
            dataService.axiosFetch("taxonomies").then(results => {
                var roleops = [{"value": '', "label": 'Bez priradenia'}];
                results.forEach(obj => { roleops.push({"value": obj.slug, "label": obj.title}); });
                this.taxonomies = roleops;
            });
        }
    };
</script>

<style>
.filter-panel{background:#fff;border:1px solid #e8e8e8;border-radius:4px;box-shadow:0 1px 2px rgba(0,0,0,.04);margin-top:20px}
.filter-head{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-bottom:1px solid #f0f0f0}
.filter-title{font-size:14px;font-weight:600;color:#0f172a}
.filter-group{margin-bottom:14px}
.filter-label{display:block;font-size:12px;font-weight:500;color:#64748b;margin-bottom:4px}
</style>
